module.exports = __webpack_public_path__ + "images/boatyard_logo_portannapolis.d6fe5f43160325889185c92dd405bd2c.png";